import { useMemo, FC } from "react";
import { useFormik, FormikProvider, FormikConfig, Form } from "formik";
import { useAppSelector } from "src/hooks/redux";
import { selectCloneTypes } from "src/redux/cloneTypes/selectors";
import { selectIndustries } from "src/redux/industries/selectors";
import { RenderFormFields } from "src/components/RenderFormFields";
import { ActionButtons } from "./ActionButtons";
import { getinquiryEditCreateFields } from "./constants";
import { InquirySettingsValues } from "./types";

interface Props {
  formikProps?: FormikConfig<InquirySettingsValues>;
  title?: string;
}

export const InquiryForm: FC<Props> = ({ formikProps, title }) => {
  const { items: cloneTypes } = useAppSelector(selectCloneTypes);
  const { data: industries } = useAppSelector(selectIndustries);

  const inquiryEditCreateFields = useMemo(() => {
    const fields = getinquiryEditCreateFields(cloneTypes, industries);

    return fields;
  }, [industries, cloneTypes]);

  const formik = useFormik<InquirySettingsValues>(formikProps);

  return (
    <section className="container">
      <h2 className="text-28 sm:text-40 font-semibold">{title}</h2>

      <FormikProvider value={formik}>
        <Form>
          <div className="flex flex-col gap-5 xl:gap-8">
            <RenderFormFields fields={inquiryEditCreateFields} />
          </div>

          <div className="mt-10">
            <ActionButtons />
          </div>
        </Form>
      </FormikProvider>
    </section>
  );
};
